// extracted by mini-css-extract-plugin
var _1 = "e2ec9c";
export { _1 as "audio_tag" }
